import { renderSliderPushMagazine } from 'js/magazin/sliderPushMagazine'
import { renderSliderArticlesMagazine } from 'js/magazin/sliderArticlesMagazine'
import { renderSliderCategoryMagazine } from 'js/magazin/sliderCategoryMagazine'
import { renderSliderFullMagazine } from 'js/magazin/sliderFullMagazine'
import { renderMasonryLayoutMagazine } from 'js/magazin/masonryLayoutMagazine'
import { renderSlider } from 'js/slider.jsx'
import { fontLoadObserver } from 'js/fontsLoad'
import { imageBlockArticleMagazine } from 'js/imageBlockArticleMagazine'

import 'js/polyfils'
import './magazineMain.scss'

window.renderSliderPushMagazine = renderSliderPushMagazine
window.renderSliderArticlesMagazine = renderSliderArticlesMagazine
window.renderSliderCategoryMagazine = renderSliderCategoryMagazine
window.renderSliderFullMagazine = renderSliderFullMagazine
window.renderMasonryLayoutMagazine = renderMasonryLayoutMagazine
window.imageBlockArticleMagazine = imageBlockArticleMagazine
window.renderSlider = renderSlider
window.fontLoadObserver = fontLoadObserver
